// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  key: __t.string().primaryKey(),
  id: __t.u32(),
  worldId: __t.string().name("world_id"),
  name: __t.string(),
  province: __t.string(),
  country: __t.string(),
  totalLandCells: __t.u32().name("total_land_cells"),
  owner: __t.option(__t.string()),
  classicalResource: __t.string().name("classical_resource"),
  napoleonicResource: __t.string().name("napoleonic_resource"),
  updatedAt: __t.timestamp().name("updated_at"),
});
